import { createRequestAtom } from '../../../shared/utils/request-atom';
import { PlanApiResponse } from '../typings';

export const getAllPlansAtom = createRequestAtom<PlanApiResponse>();

